/* eslint-disable no-restricted-globals */
/* eslint-disable import/prefer-default-export */
export const validateDate = (date) => {
  const d = new Date(date);
  return d instanceof Date && !isNaN(d.getTime());
};

export const isTextValid = (text) => Boolean(text && `${text}`.trim().length);
